$(document).ready(function () {
  function changeLocationVillas(element) {
    var filterWrapper = element.closest('.js-property-filter');
    var selectedLocationId = filterWrapper.find('option:selected').val();
    var url = filterWrapper.data('url');
    var locale = filterWrapper.data('currency-short-cut');
    var orderBy = filterWrapper.find('.is-active').data('location-order');
    var slug = filterWrapper.data('slug');

    $.ajax({
      type: 'POST',
      url: url,
      dataType: 'json',
      data: {
        locationId: selectedLocationId,
        locale: locale,
        orderBy: orderBy,
        slug: slug,
      },
      success: function (data) {
        $('.js-location-property').html(data.propertiesView);
        $('.villa-top--gallery').addClass('aos-init aos-animate');
      },
      error: function (data) {
        console.log(data);
      },
    });
  }

  if (document.readyState === 'interactive') {
    let searchVillasOptions = $('.select-items');
    if (searchVillasOptions.closest('.js-property-filter').length !== 0) {
      for (let i = 0; i < searchVillasOptions.length; i++) {
        searchVillasOptions[i].addEventListener('click', function () {
          changeLocationVillas($(this));
        });
      }
    }
  }

  $('.js-property-order-by').bind('click', function () {
    $('.js-property-order-by').removeClass('is-active');
    $(this).addClass('is-active');
    changeLocationVillas($(this));
  });
});
